<template>
  <div>
    <el-dialog
      title="同步"
      :visible.sync="dialogVisible"
      :width="transferSetting.dialogWidth"
      :before-close="handleClose"
    >
      <slot></slot>
      <div class="flex">
        <div>
          <el-table
            ref="multipleTable"
            :data="pageParam.list"
            :height="transferSetting.tableHeight"
            :style="'width:' + transferSetting.tableWidth + 'px'"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="40"
              align="center"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              v-for="(item, index) in tableColums"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            :page-sizes="[10, 20, 30, 40]"
            :style="
              'margin-top: 20px; text-align: right;width:' +
              transferSetting.tableWidth +
              'px'
            "
            :total="pageParam.total"
            :page-size="pageParam.pageSize"
            :current-page="pageParam.pageNumber"
            @current-change="changePageChange"
          ></el-pagination>
        </div>
        <el-button
          type="primary"
          icon="el-icon-arrow-right"
          @click="copyListBtn"
        ></el-button>
        <div
          :style="
            'margin-bottom:60px;width:' +
            (transferSetting.tableWidth * 1 + 40) +
            'px'
          "
        >
          <el-table
            :height="transferSetting.tableHeight"
            :data="copylist"
            style="width: 100%"
            border
          >
            <el-table-column
              v-for="(item, index) in tableColums"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="state"
              label="操作"
              width="80px"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-popconfirm
                  placement="top"
                  title="确定删除吗？"
                  @confirm="deleteCopyList(scope)"
                >
                  <div class="colorBlue" slot="reference">删除</div>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      pageParam: {},
      selectList: [],
      copylist: [],
    };
  },
  props: {
    // 配置
    transferSetting: {
      type: Object,
      default: function () {
        return {
          dialogWidth: "1300px", // 弹窗宽度
          tableWidth: 522, // 表格宽度
          tableHeight: 530, // 表格高度
        };
      },
    },
    // table 列配置
    tableColums: {
      type: Array,
      required: true,
    },
  },
  watch: {
    "pageParam.list": {
      handler () {
        this.toggleSelection();
      },
      deep: true,
    },
    copylist: {
      handler () {
        this.toggleSelection();
      },
      deep: true,
    },
    dialogVisible (val) {
      if (!val) {
        this.copylist = [];
        this.$parent.scheduleSettingSearchForm.pageNumber = 1;
      }
    },
  },
  methods: {
    // 提交按钮
    sumbitBtn () {
      if (this.copylist.length == 0) {
        this.$message.error("请选择同步数据");
        return;
      }
      this.$confirm("确认同步数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("getCopyList", this.copylist);
        })
        .catch(() => { });
    },
    // 左边table 根据copylist自动勾选选中数据
    toggleSelection () {
      this.$refs.multipleTable.clearSelection();
      this.pageParam.list.forEach((item) => {
        this.copylist.forEach((_item) => {
          if (item.id == _item.id) {
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(item, true);
            });
          }
        });
      });
    },
    handleSelectionChange (val) {
      this.selectList = val;
    },
    // 新增同步数据，并去重
    copyListBtn () {
      if (this.selectList.length != 0) {
        let arr = this.copylist.concat(this.selectList);
        arr = [...new Set(arr)];
        this.copylist = arr;
      }
    },
    // 删除同步数据
    deleteCopyList (e) {
      let index = e.$index;
      this.copylist.splice(index, 1);
    },
    // 初始化数据
    initData (obj) {
      this.dialogVisible = true;
      this.selectList = [];
      this.$parent.getScheduleClassInfoList();
    },
    handleClose (done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    // 改变页码
    changePageChange (val) {
      this.selectList = [];
      this.$parent.scheduleSettingSearchForm.pageNumber = val;
      this.$parent.getScheduleClassInfoList();
    },
  },
};
</script>
<style lang="less" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.colorBlue {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/transfer.vue